<div class="select-wrapper">
    <ng-select [items]="selectItems"
               [virtualScroll]="true"
               bindLabel="name"
               groupBy="type"
               [placeholder]="isVendorsLoading ? 'Loading...' : 'Select vendor or category'"
               [(ngModel)]="selectedVendorOrCategory"
               class="mcc mcc-sm">

        <ng-template ng-option-tmp let-item="item" let-index="index">
            <div class="vendor-option">
                <span class="name">{{item.name}}</span>
                <i *ngIf="item.sponsored" class="fa fa-star star" aria-hidden="true"></i>
            </div>
        </ng-template>

    </ng-select>
    <spinner [spinnerShow]="isVendorsLoading"></spinner>
</div>

<div class="select-wrapper">
    <ng-select *ngIf="selectedCategory"
               [items]="selectVendorItems"
               [virtualScroll]="true"
               bindLabel="name"
               groupBy="type"
               [placeholder]="isCategoryVendorsLoading ? 'Loading...' : 'Select vendor'"
               [(ngModel)]="selectedVendor"
               class="mcc mcc-sm">

        <ng-template ng-option-tmp let-item="item" let-index="index">
            <div class="vendor-option">
                <span class="name">{{item.name}}</span>
                <i *ngIf="item.sponsored" class="fa fa-star star" aria-hidden="true"></i>
            </div>
        </ng-template>

    </ng-select>
    <spinner [spinnerShow]="isCategoryVendorsLoading"></spinner>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/service-request/vendor-select/vendor-select.component.html